import { Heading as HeadingToExtend } from '@tiptap/extension-heading';

export const Heading = HeadingToExtend.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            class: {
                default: null
            },
            style: null
        }
    }
})
